import type { BodyRequest } from '@pba/react-utils';
import type { paths } from '@pba/types-openapi-node';
import type { AxiosResponse } from 'axios';
import { getNodeApiAxiosInstance } from '#client';
import { routes } from '../routes';

export type UnsubscribeRingcentralEmailRequestBody =
  paths['/ringcentral/email/unsubscribe']['post']['requestBody']['content']['application/json'];

export const unsubscribeRingcentralEmail = async ({ body }: BodyRequest<UnsubscribeRingcentralEmailRequestBody>) =>
  getNodeApiAxiosInstance().post<unknown, AxiosResponse<unknown>>(routes.ringcentral.email.unsubscribe.create, body);
